import { FormEvent } from "react";
import { Card, CardBody, Col, Form, Row } from "reactstrap";
import { BasicFloatingInputControlTitle } from "../../../../../../constants";
import { BasicFloatingInputControlSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import CommonCardFooter from "../../../common/CommonCardFooter";
import BasicFloatingInputBody from "./basicFloatingInputBody";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const BasicFloatingInputControl = () => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => e.preventDefault();

  return (
    <Col xl="6">
      <Card className="custom-basic-input">
        <CommonCardHeader title={BasicFloatingInputControlTitle} span={BasicFloatingInputControlSubTitle} />
        <Form className="theme-form" onSubmit={handleSubmit}>
          <CardBody className="custom-input">
            <Row>
              <BasicFloatingInputBody />
            </Row>
          </CardBody>
          <CommonCardFooter color1="primary" color2="light" footerClass="text-end" />
        </Form>
      </Card>
    </Col>
  );
};
export default BasicFloatingInputControl;
